import { mbToBytes } from '../utils/convertSize';

const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
const docExtensions = ['pdf', 'doc', 'docx'];

export const RESUME_ALLOWED_FORMATS = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/png',
  'image/gif',
  'image/jpeg'
];

export const RESUME_ALLOWED_FILE_EXT = imageExtensions.concat(docExtensions);

export const MAX_RESUME_SIZE = mbToBytes(3);

export const AVATAR_ALLOWED_FORMATS = ['image/png', 'image/gif', 'image/jpeg'];
export const AVATAR_ALLOWED_FILE_EXT = imageExtensions;
export const MAX_AVATAR_SIZE = mbToBytes(1);
export const MIN_YEAR_EDUCATION_EXPERIENCE = 1920;

export const KEYBOARD_EDITING_KEYS = [
  'backspace',
  'clear',
  'copy',
  'crsel',
  'cut',
  'delete',
  'eraseeof',
  'exsel',
  'insert',
  'paste',
  'redo',
  'undo',
  'arrowleft',
  'arrowright',
  'arrowup',
  'arrowdown',
  'end',
  'home',
  'pagedown',
  'pageup',
  'tab',
  'enter',
];